import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Layout, Header } from 'app/theme/layout'

import ImageHero from 'app/theme/ImageHero'
import { OccasionPageGrid, OccasionPageGridRow } from './shared/OccasionPageGrid'
import Calculator from 'app/theme/calculator'
import CuisineTypes from 'app/theme/sections/CuisineTypes'
import HowItWorks from 'app/theme/sections/HowItWorks'
import HowItWorksLarge from 'app/theme/sections/HowItWorksLarge'
import WhyWorkWithUs from 'app/theme/sections/WhyWorkWithUs'
import FeaturedClients from 'app/theme/sections/FeaturedClients'
import workplace from 'assets/img/workplace.jpg'
import occasionsMain from 'assets/img/occasions-main.jpg'
import occasionCatering1 from 'assets/img/occasions-convenience.jpg'
import occasionCatering2 from 'assets/img/occasions-variety.jpg'
import occasionCatering3 from 'assets/img/occasions-deliciousness.jpg'
import occasionCatering4 from 'assets/img/occasions-service-guarantee.jpg'
import LeadModal from 'app/leads/LeadModal'
import { useModalState } from 'lib/modal'

export default function OccasionPage(props) {
  const { openModal, ...modalState } = useModalState()

  const {
    title = 'Corporate Catering',
    description = 'Make your wedding more memorable with a delicious food truck experience on your special day',
  } = props

  return (
    <Layout header={<Header occasionMenu />}>
      <Helmet>
        <title>Occasion - Roaming Hunger</title>
        <meta
          name="description"
          content="Roaming Hunger is the hub for all things street food. Find and follow food trucks and food carts in your city live!"
        />
        <meta name="og:title" content="Occasion" />
      </Helmet>
      <LeadModal
        {...modalState}
      />
      <ImageHero
        imageUrl={workplace}
        title={title}
        onButtonClick={openModal}
        description={description}
      />
      <div className="container text-center">
        <h2 className="text-4xl text-navy font-platform leading-tight mt-10 mb-5">
          Corporate Catering with Delicious Food Trucks
        </h2>
        <p className="font-light mb-10 text-gray-900">
          Engage employees, increase productivity and make staff feel valued.
          Food trucks are an easy and inexpensive way to celebrate a company
          milestone or retain talent through an employee perk program.
        </p>
        <img src={occasionsMain} />
      </div>
      <IntroGrid />
      <FeaturedClients onButtonClick={openModal} />
      <GridSection2 />
      <WhyWorkWithUs onButtonClick={openModal} />
      <CuisineTypes baseUrl='/food-truck-catering' />
      <HowItWorks onButtonClick={openModal} />
      <HowItWorksLarge onButtonClick={openModal} />
      <Calculator onButtonClick={openModal} />
    </Layout>
  )
}

function IntroGrid() {
  return (
    <OccasionPageGrid>
      <OccasionPageGridRow
        heading="Convenience"
        content="Experience our seemless booking with a designated point of contact and your company account preferences on file. Whether you plan to book food trucks once or over and over again, you'll never have to lift a finger."
        image={occasionCatering1}
        reverse
      />
      <OccasionPageGridRow
        heading="Variety"
        content="With thousands of options, you can rest assured we can secure a great spread no matter where you work. With everything from burger bars to pad thai to gourmet salads, we ensure a healthy mix of options optimized to keep everyone well fed."
        image={occasionCatering2}
      />
    </OccasionPageGrid>
  )
}

function GridSection2() {
  return (
    <OccasionPageGrid>
      <OccasionPageGridRow
        heading="Deliciousness"
        content="Fresh, made-to-order food satisfies uncharted taste buds. Festive, modern and interactive, food trucks create an unforgettable food experience for your team as often as you'd like."
        image={occasionCatering3}
        reverse
      />
      <OccasionPageGridRow
        heading="Service Guarantee"
        content="With thousands of options, you can rest assured we can secure a great spread no matter where you work. With everything from burger bars to pad thai to gourmet salads, we ensure a healthy mix of options optimized to keep everyone well fed."
        image={occasionCatering4}
      />
    </OccasionPageGrid>
  )
}
